<template>
  <h2>Heading</h2>
  <v-icon>mdi-access-point</v-icon>
</template>
